// src/hooks/useDebounce.ts
// Hook para debounce de valores

import { useEffect, useState } from 'react';

/**
 * Hook para debounce de valores
 * @param value - Valor a debounce
 * @param delay - Delay en milisegundos (default: 500)
 * @returns Valor debounced
 */
export function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Set timeout para actualizar el valor después del delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup: cancelar el timeout si el valor cambia antes del delay
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
